/**
 * Generate subtitle for Gantt chart header
 * @param {Array} categories - Array of category objects
 * @param {Date} currentViewDate - The current date being viewed
 * @param {Function} t - Translation function from i18next
 * @returns {String} Generated subtitle string
 */
export const generateSubtitle = (categories, currentViewDate, t) => {
  if (categories.length === 0) {
    return t('common:gantt.no_tasks');
  }

  const totalTasks = categories.reduce((sum, category) => sum + category.tasks.length, 0);

  return `${t('common:gantt.categories')}: ${categories.length} • ${t('common:gantt.tasks')}: ${totalTasks} • ${t('common:gantt.currently_viewing')}: ${currentViewDate.toLocaleDateString('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })}`;
};
